export default __webpack_public_path__ + "static/media/InstantMessagingApp.67e41f66.jpg";